import ApiResourceManager from '../ApiResourceManager';

export default class DashboardReservationManager extends ApiResourceManager {
  /**
   * Whether reservations are on, and whether switching them on needs a
   * notification address from the partner (no owner invited yet, or settings
   * that hold none). Read before the paywall opens: it buys the licence before
   * it runs the activation, so the address has to be asked for up front.
   */
  getActivation = (companyId) =>
    this.request({
      method: 'GET',
      url: `/reservations/companies/${companyId}/activation`,
    });

  /**
   * Switch reservations on through the shop backend, which enforces the
   * Partner Plan licence and decides whether to create the settings or flip
   * the switch on the existing ones. `notificationEmail` is where new bookings
   * are mailed when the restaurant has no address on file; the backend uses
   * the owner's address before it.
   */
  activateCompany = (companyId, { notificationEmail = null } = {}) =>
    this.request({
      method: 'POST',
      url: `/reservations/companies/${companyId}/activate-reservations`,
      data: notificationEmail ? { notification_email: notificationEmail } : {},
    });

  /**
   * Switch reservations off through the shop backend. Never licence-gated.
   */
  deactivateCompany = (companyId) =>
    this.request({
      method: 'POST',
      url: `/reservations/companies/${companyId}/deactivate-reservations`,
    });
}
